var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1.925C19.25 2.25 18.475 2.475 17.65 2.575C18.5 2.075 19.15 1.275 19.45 0.3C18.65 0.775 17.775 1.1 16.85 1.3C16.1 0.5 15.025 0 13.85 0C11.575 0 9.75 1.85 9.75 4.1C9.75 4.425 9.775 4.725 9.85 5.025C6.45 4.875 3.45 3.225 1.425 0.75C-0.0249999 3.35 1.6 5.5 2.675 6.225C2.025 6.225 1.375 6.025 0.825 5.725C0.825 7.75 2.25 9.425 4.1 9.8C3.7 9.925 2.8 10 2.25 9.875C2.775 11.5 4.3 12.7 6.075 12.725C4.675 13.825 2.625 14.7 0 14.425C1.825 15.6 3.975 16.275 6.3 16.275C13.85 16.275 17.95 10.025 17.95 4.625C17.95 4.45 17.95 4.275 17.925 4.1C18.775 3.475 19.475 2.75 20 1.925Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6d659a78b095dc0b639cb7528fa1015c.svg";
export { ForwardRef as ReactComponent };